import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1998985d&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1998985d",
  null
  
)

export default component.exports